(function () {
  const parseI18n = () => {
    const node = document.querySelector('[data-cart-added-i18n]');
    if (!node) {
      return {};
    }
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  const formatMoney = (cents) => {
    const amount = Math.round(Number(cents) || 0);
    const lira = Math.floor(amount / 100);
    const kurus = amount % 100;
    const str = String(lira);
    let formatted = '';
    let count = 0;

    for (let index = str.length - 1; index >= 0; index -= 1) {
      if (count > 0 && count % 3 === 0) {
        formatted = `${str.charAt(index)}.${formatted}`;
      } else {
        formatted = `${str.charAt(index)}${formatted}`;
      }
      count += 1;
    }

    if (kurus > 0) {
      const kurusString = kurus < 10 ? `0${kurus}` : String(kurus);
      formatted += `,${kurusString}`;
    }

    return `${formatted}\u00a0TL`;
  };

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  const updateHeaderCount = (count, i18n) => {
    const safeCount = Number(count) || 0;
    const desktopCount = document.getElementById('cart-count');
    const mobileCount = document.getElementById('cart-count-mobile');
    const cartLink = document.getElementById('header-cart-link');
    const badgeNodes = document.querySelectorAll('[data-cart-count]');

    if (desktopCount) {
      desktopCount.textContent = safeCount;
    }

    if (mobileCount) {
      mobileCount.textContent = safeCount;
      mobileCount.classList.toggle('site-header__cart-count--zero', safeCount === 0);
    }

    badgeNodes.forEach((node) => {
      node.textContent = safeCount;
      node.classList.toggle('site-header__cart-count--zero', safeCount === 0);
    });

    if (cartLink && i18n.mobile_badge) {
      cartLink.setAttribute('aria-label', i18n.mobile_badge.replace('__COUNT__', String(safeCount)));
    }
  };

  const getLinePrices = (item) => {
    const finalLine = Number(item.final_line_price || item.line_price || item.final_price || item.price || 0);
    const originalLine = Number(item.original_line_price || item.original_price || finalLine);
    const onSale = originalLine > finalLine;
    return { finalLine, originalLine, onSale };
  };

  const buildItemHtml = (item, i18n) => {
    const featuredImage = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
    const imageUrl = item.image || featuredImage || '';
    const vendor = item.vendor || '';
    const title = item.product_title || item.title || '';
    const url = item.url || '#';
    const quantity = Number(item.quantity) || 1;
    const prices = getLinePrices(item);
    const qtyLabel = (i18n.quantity || '{{ count }}').replace(/\{\{\s*count\s*\}\}/g, String(quantity));

    let priceHtml = '';

    if (prices.onSale) {
      priceHtml += `<span class="cart-added-popover__price-compare">${formatMoney(prices.originalLine)}</span>`;
      priceHtml += `<span class="cart-added-popover__price-current">${formatMoney(prices.finalLine)}</span>`;
    } else {
      priceHtml += `<span class="cart-added-popover__price-current">${formatMoney(prices.finalLine)}</span>`;
    }

    let html = '';

    html += `<a class="cart-added-popover__media" href="${escapeHtml(url)}">`;
    if (imageUrl) {
      html += `<img class="cart-added-popover__image" src="${escapeHtml(imageUrl)}" alt="" width="72" height="72" loading="lazy">`;
    }
    html += '</a>';
    html += '<div class="cart-added-popover__body">';

    if (vendor) {
      html += `<p class="cart-added-popover__vendor">${escapeHtml(vendor)}</p>`;
    }

    html += `<a class="cart-added-popover__name" href="${escapeHtml(url)}">${escapeHtml(title)}</a>`;
    html += `<div class="cart-added-popover__prices">${priceHtml}</div>`;
    html += `<p class="cart-added-popover__qty">${escapeHtml(qtyLabel)}</p>`;
    html += '</div>';

    return html;
  };

  const SCROLL_TOAST_THRESHOLD = 120;
  const TOAST_VISIBLE_MS = 6000;

  let popoverEl = null;
  let titleEl = null;
  let itemEl = null;
  let toastEl = null;
  let toastMessageEl = null;
  let toastItemEl = null;
  let toastHideTimer = null;
  let hoverHideTimer = null;
  let closeOnOutsideHandler = null;
  let i18n = {};

  const preferToastFeedback = () => {
    if (window.scrollY > SCROLL_TOAST_THRESHOLD) {
      return true;
    }

    const anchor = document.querySelector('[data-cart-added-anchor]');

    if (!anchor) {
      return false;
    }

    const rect = anchor.getBoundingClientRect();
    return rect.bottom < 0 || rect.top > window.innerHeight;
  };

  const hidePopover = () => {
    if (!popoverEl) {
      return;
    }

    popoverEl.setAttribute('hidden', '');

    if (closeOnOutsideHandler) {
      document.removeEventListener('click', closeOnOutsideHandler);
      document.removeEventListener('keydown', closeOnOutsideHandler);
      closeOnOutsideHandler = null;
    }
  };

  const isToastVisible = () => {
    return Boolean(toastEl && toastEl.classList.contains('is-visible'));
  };

  const scheduleToastHide = () => {
    if (!toastEl) {
      return;
    }

    if (toastHideTimer) {
      window.clearTimeout(toastHideTimer);
    }

    toastHideTimer = window.setTimeout(() => {
      hideToast();
    }, TOAST_VISIBLE_MS);
  };

  const pauseToastAutoHide = () => {
    if (toastHideTimer) {
      window.clearTimeout(toastHideTimer);
      toastHideTimer = null;
    }
  };

  const hideToast = () => {
    if (!toastEl) {
      return;
    }

    if (toastHideTimer) {
      window.clearTimeout(toastHideTimer);
      toastHideTimer = null;
    }

    toastEl.classList.remove('is-visible');

    window.setTimeout(() => {
      if (toastEl && !toastEl.classList.contains('is-visible')) {
        toastEl.setAttribute('hidden', '');
      }
    }, 260);
  };

  const showToast = (lineItem) => {
    if (!toastEl || !toastMessageEl || !toastItemEl || !lineItem) {
      return;
    }

    hidePopover();

    toastMessageEl.textContent = i18n.toast_message || 'Added to cart';
    toastItemEl.innerHTML = buildItemHtml(lineItem, i18n);

    toastEl.removeAttribute('hidden');

    window.requestAnimationFrame(() => {
      toastEl.classList.add('is-visible');
    });

    scheduleToastHide();
  };

  const bindOutsideClose = () => {
    if (closeOnOutsideHandler) {
      document.removeEventListener('click', closeOnOutsideHandler);
      document.removeEventListener('keydown', closeOnOutsideHandler);
    }

    closeOnOutsideHandler = (event) => {
      if (event.type === 'keydown' && event.key !== 'Escape') {
        return;
      }

      if (event.type === 'click') {
        const anchor = document.querySelector('[data-cart-added-anchor]');
        if (anchor && anchor.contains(event.target)) {
          return;
        }
      }

      hidePopover();
    };

    window.setTimeout(() => {
      document.addEventListener('click', closeOnOutsideHandler);
      document.addEventListener('keydown', closeOnOutsideHandler);
    }, 0);
  };

  const fillPopover = (cart, focusItem) => {
    if (!titleEl || !itemEl) {
      return;
    }

    const count = Number(cart?.item_count) || 0;
    const titleTemplate = i18n.title || 'Sepetim ({{ count }} Ürün)';
    titleEl.textContent = titleTemplate.replace(/\{\{\s*count\s*\}\}/g, String(count));

    const items = Array.isArray(cart?.items) ? cart.items : [];
    let item = focusItem || null;

    if (!item && items.length > 0) {
      item = items[items.length - 1];
    }

    if (!item || count === 0) {
      itemEl.classList.add('cart-added-popover__item--empty');
      itemEl.innerHTML = `<p class="cart-added-popover__empty">${escapeHtml(i18n.empty_cart || '')}</p>`;
      return;
    }

    itemEl.classList.remove('cart-added-popover__item--empty');
    itemEl.innerHTML = buildItemHtml(item, i18n);
  };

  const openPopover = (cart, focusItem, dismissMode) => {
    if (!popoverEl) {
      return;
    }

    hideToast();
    fillPopover(cart, focusItem);
    popoverEl.removeAttribute('hidden');

    if (dismissMode === 'outside') {
      bindOutsideClose();
    }
  };

  const cancelHoverHide = () => {
    if (hoverHideTimer) {
      window.clearTimeout(hoverHideTimer);
      hoverHideTimer = null;
    }
  };

  const scheduleHoverHide = () => {
    cancelHoverHide();
    hoverHideTimer = window.setTimeout(() => {
      hidePopover();
    }, 220);
  };

  const bindCartHoverPreview = () => {
    const anchor = document.querySelector('[data-cart-added-anchor]');

    if (!anchor || !popoverEl || anchor.dataset.cartHoverBound === '1') {
      return;
    }

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!canHover) {
      return;
    }

    anchor.dataset.cartHoverBound = '1';

    anchor.addEventListener('mouseenter', () => {
      cancelHoverHide();

      if (isToastVisible()) {
        return;
      }

      fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('cart');
          }

          return response.json();
        })
        .then((cart) => {
          if (!anchor.matches(':hover')) {
            return;
          }

          updateHeaderCount(Number(cart.item_count) || 0, i18n);
          openPopover(cart, null, 'hover');
        })
        .catch(() => {});
    });

    anchor.addEventListener('mouseleave', (event) => {
      if (toastEl && event.relatedTarget && toastEl.contains(event.relatedTarget)) {
        return;
      }

      if (popoverEl && event.relatedTarget && popoverEl.contains(event.relatedTarget)) {
        return;
      }

      scheduleHoverHide();
    });

    popoverEl.addEventListener('mouseenter', () => {
      cancelHoverHide();
    });

    popoverEl.addEventListener('mouseleave', (event) => {
      if (anchor.contains(event.relatedTarget)) {
        return;
      }

      scheduleHoverHide();
    });
  };

  const showCartAddedPopover = (cart, lineItem) => {
    if (!lineItem) {
      return;
    }

    const count = Number(cart?.item_count) || Number(lineItem.quantity) || 1;
    updateHeaderCount(count, i18n);

    if (preferToastFeedback()) {
      showToast(lineItem);
      return;
    }

    if (!popoverEl || !titleEl || !itemEl) {
      showToast(lineItem);
      return;
    }

    openPopover(cart, lineItem, 'outside');
  };

  const init = () => {
    popoverEl = document.querySelector('[data-cart-added-popover]');
    if (!popoverEl) {
      return;
    }

    titleEl = popoverEl.querySelector('[data-cart-added-title]');
    itemEl = popoverEl.querySelector('[data-cart-added-item]');
    toastEl = document.querySelector('[data-cart-added-toast]');
    toastMessageEl = toastEl ? toastEl.querySelector('[data-cart-added-toast-message]') : null;
    toastItemEl = toastEl ? toastEl.querySelector('[data-cart-added-toast-item]') : null;
    i18n = parseI18n();

    popoverEl.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    if (toastEl) {
      const toastClose = toastEl.querySelector('[data-cart-added-toast-close]');
      if (toastClose) {
        toastClose.addEventListener('click', () => {
          hideToast();
        });
      }

      toastEl.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      toastEl.addEventListener('mouseenter', () => {
        pauseToastAutoHide();
      });

      toastEl.addEventListener('mouseleave', () => {
        if (isToastVisible()) {
          scheduleToastHide();
        }
      });
    }

    bindCartHoverPreview();

    window.showCartAddedPopover = showCartAddedPopover;
    window.hideCartAddedPopover = () => {
      hidePopover();
      hideToast();
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelector('[data-cart-added-popover]')) {
      init();
    }
  });
})();
